import useLoading from '../../control/loading/useLoading'
import useCallApi from '../../utilities/axios'
import * as umServiceURL from './umServiceURL'

// export type FormType = {
//     username: string
// }

const useCheckEmail = () => {
    const callApi = useCallApi()
    const loadingHook = useLoading()

    const postCheck = async (username: string, type: number = 2) => {
        try {
            loadingHook.loadingOpen()
            const { data } = await callApi.axiosPost<any>({
                url: umServiceURL.postCheckEmail,
                params: { username, type },
            })

            return data
        } finally {
            loadingHook.loadingClose()
        }
    }
    return { postCheck }
}

export default useCheckEmail
